import ApiCore from "./api_core"
import { NewDrugOrder } from "./types"

export default new class {
    createOrder(orders: NewDrugOrder[]) {
        return ApiCore.postJson('drug_orders', orders)
    }

    getDrugs(params={} as Record<string, string | number>) {
        return ApiCore.getJson('drugs', params)
    }

    getOPDDrugs(params={} as Record<string, string | number>) {
        return ApiCore.getJson('OPD_drugslist', params)
    }
}